<template>
  <div>
    <template v-if="enableViewReportsProject || (admins && admins.length)">
      <ProjectReportsOccRateParentBar />
      <router-view ></router-view>
    </template>
    <template v-else>
      <v-card elevation="0" class="mt-3">
        <v-card-text class="text-center">
          <v-icon size="80">mdi-alert-circle-outline</v-icon>
          <h3 class="mt-4">{{ $t('project.sorry_you_do_not_have_permission_to_access_data') }}</h3>
        </v-card-text>
      </v-card>
    </template>
  </div>
</template>
<script>
import ProjectReportsOccRateParentBar from "@/components/ProjectReportsOccRateParentBar.component.vue";
export default {
  components: {
    ProjectReportsOccRateParentBar,
  },
  data(){
    return {
      projectId: this.$route.params.projectId,
    }
  },
  computed: {
    admins() {
      return this.$store.getters["admin/getByProjectId"](this.projectId);
    },
    employees() {
      return this.$store.getters["employee/getByProjectId"](this.projectId);
    },
    enableViewReportsProject(){
      return this.employees?.find(d => d.enableViewReportsProject)
    }
  }
};
</script>

<style>
</style>